import { filterPayerOption, formatPayerOptionLabel } from 'components/lab/payer/PayerOptionLabel'

export type PayerOption = { value: number; label: string; matchedName?: string | null }

export const toPayerOptions = (
  payers: { payerId: number | string; name: string; matchedName?: string | null }[] | undefined,
): PayerOption[] =>
  (payers ?? []).map((payer) => ({
    value: Number(payer.payerId),
    label: payer.name,
    matchedName: payer.matchedName,
  }))

// The results table's sticky <thead> sits at z-index 1000 (DataTable), so a
// menu rendered in flow is painted over. Portalling to <body> lifts it out of
// that stacking context; the z-index clears the header for good measure.
export const menuOverTableProps = {
  menuPortalTarget: document.body,
  styles: { menuPortal: (base: Record<string, unknown>) => ({ ...base, zIndex: 9999 }) },
}

/** Props shared by the payor pickers on the Charge Rules screen. */
export const payerSelectProps = {
  formatOptionLabel: formatPayerOptionLabel,
  filterOption: filterPayerOption,
  ...menuOverTableProps,
}
